import PhoneInput from 'react-phone-input-2';
import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 TELÉFONO — react-phone-input-2

    Recibe las clases por props (containerClass, inputClass...), así que
    no hace falta pelear con especificidad: le pasamos las nuestras y
    listo. Su CSS base se importa una vez en App.js.
*/

export const FieldPhone = ({
    id, name, label, hint, error,
    value, onChange, country = 'ar',
    placeholder = '11 2345 6789',
    isRequired = false, isDisabled = false,
    span = 1, ...rest
}) => {

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (

    <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
        isRequired={isRequired} isDisabled={isDisabled} span={span} >

        <PhoneInput
            country={country}
            value={value} onChange={onChange}
            placeholder={placeholder}
            disabled={isDisabled}
            containerClass={`${BLOCK}__phone`}
            inputClass={`${BLOCK}__input ${BLOCK}__phone_input`}
            buttonClass={`${BLOCK}__phone_button`}
            dropdownClass={`${BLOCK}__phone_dropdown`}
            searchClass={`${BLOCK}__phone_search`}
            inputProps={{
                id, name: DOM_NAME, required: isRequired, autoComplete: 'nope',
                'data-lpignore': 'true', 'data-1p-ignore': 'true', 'data-form-type': 'other',
            }}
            enableSearch searchPlaceholder="Buscar país…" searchNotFound="Sin resultados"
            {...rest}
        />

    </FieldShell>
);
};
